import { getApiBaseUrl } from "../config";

export const AUTH_USER_STORAGE_KEY = "user";

export const buildStoredUser = (user) => ({
  id: user?._id || user?.id,
  email: user?.email,
  ...(user?.type === "individual" && { firstName: user?.firstName }),
  ...(user?.type === "individual" && { lastName: user?.lastName }),
  ...(user?.type === "company" && {
    memberRegistrationId: user?.member_registration,
  }),
  ...(user?.type === "company" && {
    companyProfileId: user?.company_profile || user?.companyProfileId,
  }),
  ...(user?.type === "company" && { companyName: user?.companyName }),
  type: user?.type,
  isVerified: user?.isVerified,
  mfaEnabled: user?.mfaEnabled,
  mfaMethod: user?.mfaMethod,
  mustChangePassword: user?.mustChangePassword,
  role: user?.role
    ? {
        name: user.role?.name,
        id: user.role?.id || user.role?._id,
      }
    : undefined,
});

export const buildReduxUser = (user) => ({
  mailid: user?.email,
  ...(user?.type === "individual" && { firstName: user?.firstName }),
  ...(user?.type === "individual" && { lastName: user?.lastName }),
  ...(user?.type === "company" && {
    memberRegistrationId: user?.member_registration,
  }),
  ...(user?.type === "company" && {
    companyProfileId: user?.company_profile || user?.companyProfileId,
  }),
  ...(user?.type === "company" && { companyName: user?.companyName }),
  type: user?.type,
  id: user?._id || user?.id,
  timezone: "UTC",
  mfaEnabled: user?.mfaEnabled,
  mfaMethod: user?.mfaMethod,
});

export const persistAuthUser = (user) => {
  localStorage.setItem(
    AUTH_USER_STORAGE_KEY,
    JSON.stringify(buildStoredUser(user)),
  );
};

export const clearAuthUser = () => {
  localStorage.removeItem(AUTH_USER_STORAGE_KEY);
};

export const getStoredAuthUser = () => {
  const raw = localStorage.getItem(AUTH_USER_STORAGE_KEY);
  return raw ? JSON.parse(raw) : null;
};

export const fetchAuthSession = async () => {
  const response = await fetch(`${getApiBaseUrl()}/auth/me`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch auth session");
  }

  const payload = await response.json();
  return payload?.data?.user;
};